import ArrowDown from "assets/svg/arrow-down-2.svg";
import React, { FC, useEffect, useRef, useState } from "react";

import styles from "./style.module.css";

type Props = {
  list: { key: string; value: string }[];
  isRtl: boolean;
  onChange: (item: { key: string; value: string }) => void;
  selectedKey?: { key: string; value: string } | undefined;
};

const CustomSelectOption: FC<Props> = ({
  list,
  isRtl = true,
  onChange,
  selectedKey,
}) => {
  const [selected, setSelected] = useState(list[0]);
  const [activated, setActivated] = useState(false);
  const ref = useRef(null);
  const onActivate = () => {
    setActivated(!activated);
  };
  const onListClicked = (item: { key: string; value: string }) => {
    onChange(item);
    setSelected(item);
    setActivated(false);
  };
  useEffect(() => {
    const handleOutSideClick = (event: any) => {
      if (ref.current) {
        // @ts-ignore
        if (!ref.current?.contains(event.target) &&
          !event.target.classList.contains("list-handler")
        ) {
          setActivated(false);
        }
      }
    };
    window.addEventListener("mousedown", handleOutSideClick);
    return () => {
      window.removeEventListener("mousedown", handleOutSideClick);
    };
  }, [ref]);
  useEffect(() => {
    if (selectedKey) {
      setSelected(selectedKey);
    }
  }, [selectedKey]);
  return (
    <>
      {list.length ? (
        <div className={styles.container}>
          <button
            onClick={onActivate}
            className={`list-handler ${styles.listHandler}`}
          >
            {selected.value}{" "}
            <ArrowDown className="inline-block h-fit w-[14px] fill-current text-[#999999]" />
          </button>
          {activated && (
            <ul
              className={`${isRtl ? "right-0" : "left-0"} ${
                styles.listWrapper
              }`}
              ref={ref}
            >
              {list.map((item, index) => {
                return (
                  <li key={index}>
                    <button
                      onClick={() => onListClicked(item)}
                      className={`${
                        selected.key === item.key && styles.active
                      }`}
                    >
                      {item.value}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default CustomSelectOption;
